// Image→3D engine registry for the composer's generation settings.
//
// Lived in SelfHost3D.js until that client was deleted (the editor stopped
// talking to the GPU platform directly on 2026-08-07 — submission now goes
// through the ev api's /api/ai3d routes, which hold the only platform
// credential). Only the picker survived the move, so it lives here.
//
// `key` is what the browser stores on payload.gen3d.engine and sends to
// /api/ai3d/generate. The platform-side model id it maps to is NOT here: the
// ev api owns that mapping (_ENGINE_VENDORS in app/surfaces/api/misc.py), and
// a second copy in this bundle would be a stale trap, since nothing here reads
// it any more.
//
// `labelKey` (not a vendor name) is what teachers see: the UI never names the
// model or its version, so which engine backs "Standard" can change without
// the label going stale — and without advertising our stack.
// Default flipped to TRELLIS.2 (2026-08-07): measured on the GB10 with the same
// reference image, trellis generates in 4m01s vs hunyuan's 6m50s — and queue
// wait multiplies every saved minute. Labels stay engine-agnostic on purpose.
export const ENGINES = [
  { key: "trellis-2", labelKey: "GEN3D_ENGINE_STANDARD", labelFallback: "Standard", default: true },
  { key: "hunyuan3d-2.1", labelKey: "GEN3D_ENGINE_ALTERNATIVE", labelFallback: "Alternative", default: false },
];

/** The engine `key` names, else the registry default. Never returns undefined. */
export function resolveEngine(key) {
  return ENGINES.find((e) => e.key === key) || ENGINES.find((e) => e.default) || ENGINES[0];
}
